module.exports = __webpack_public_path__ + "static/media/gdpr-consulting.ef40c2be.pdf";